import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { OfferPagePromoBanners } from './OfferPagePromoBanners';
import { actions } from './OfferPagePromoBanners.actions';
import {
    getHeaderNames,
    getBanners,
    getBannersGallery,
    getDimensions,
    getMimeTypes,
    getProportions
} from './OfferPagePromoBanners.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderNames,
    banners: getBanners,
    bannersGallery: getBannersGallery,
    dimensions: getDimensions,
    mimeTypes: getMimeTypes,
    proportions: getProportions
});

const OfferPagePromoBannersComponent = connect(
    function mapStateToProps(state, {onSave, showConstructor, showConstructorPromoCode, showConstructorPromoCodeList}) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.banners.loading,
            totalPages: state.banners.total,
            locales: state.banners.locales,
            onSave: onSave,
            showConstructor: showConstructor,
            showConstructorPromoCode: showConstructorPromoCode,
            showConstructorPromoCodeList: showConstructorPromoCodeList
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getBanners: actions.getBanners,
            getLocales: actions.getLocales,
            getDimensions: actions.getDimensions,
            getMimeTypes: actions.getMimeTypes,
            saveBannerPresets: actions.saveBannerPresets
        };
    }
)(OfferPagePromoBanners);

export default OfferPagePromoBannersComponent;
